import { useQuery } from '@tanstack/react-query';
import type { MediaId } from 'models/Media';
import { mediaQuery } from 'networking/mindfeed/queries/media';

// A media file and its URLs. Several files asked for at the same time are
// fetched in one request (see getMedia). With no id the query is defined
// but doesn't run.
export default function useMedia(mediaId?: MediaId) {
  return useQuery(mediaQuery(mediaId));
}
